/* eslint-disable */
/* tslint:disable */
/*
 * ---------------------------------------------------------------
 * ## THIS FILE WAS GENERATED VIA SWAGGER-TYPESCRIPT-API        ##
 * ##                                                           ##
 * ## AUTHOR: acacode                                           ##
 * ## SOURCE: https://github.com/acacode/swagger-typescript-api ##
 * ---------------------------------------------------------------
 */

import { AdminRegionDto, AdminRegionRequestDto } from './data-contracts';
import { ContentType, HttpClient, RequestParams } from './http-client';

export class AdminRegionService<SecurityDataType = unknown> {
  http: HttpClient<SecurityDataType>;

  constructor(http: HttpClient<SecurityDataType>) {
    this.http = http;
  }

  /**
   * No description
   *
   * @tags AdminRegionService
   * @name UpdateRegion
   * @summary Update Region
   * @request PUT:/v1/admin/regions/{amenityId}
   * @secure
   */
  updateRegion = (amenityId: number, data: AdminRegionRequestDto, params: RequestParams = {}) =>
    this.http.request<AdminRegionDto, any>({
      path: `/v1/admin/regions/${amenityId}`,
      method: 'PUT',
      body: data,
      secure: true,
      type: ContentType.Json,
      format: 'json',
      ...params,
    });
  /**
   * No description
   *
   * @tags AdminRegionService
   * @name DeleteRegion
   * @summary Delete Region
   * @request DELETE:/v1/admin/regions/{amenityId}
   * @secure
   */
  deleteRegion = (amenityId: number, params: RequestParams = {}) =>
    this.http.request<void, any>({
      path: `/v1/admin/regions/${amenityId}`,
      method: 'DELETE',
      secure: true,
      ...params,
    });
  /**
   * No description
   *
   * @tags AdminRegionService
   * @name GetRegions1
   * @summary Get Regions
   * @request GET:/v1/admin/regions
   * @secure
   */
  getRegions1 = (
    query?: {
      searchKeyword?: string;
      /**
       * Zero-based page index (0..N)
       * @min 0
       * @default 0
       */
      page?: number;
      /**
       * The size of the page to be returned
       * @min 1
       * @default 20
       */
      size?: number;
      /** Sorting criteria in the format: property,(asc|desc). Default sort order is ascending. Multiple sort criteria are supported. */
      sort?: string[];
    },
    params: RequestParams = {},
  ) =>
    this.http.request<AdminRegionDto[], any>({
      path: `/v1/admin/regions`,
      method: 'GET',
      query: query,
      secure: true,
      format: 'json',
      ...params,
    });
  /**
   * No description
   *
   * @tags AdminRegionService
   * @name CreateRegion
   * @summary Create Region
   * @request POST:/v1/admin/regions
   * @secure
   */
  createRegion = (data: AdminRegionRequestDto, params: RequestParams = {}) =>
    this.http.request<AdminRegionDto, any>({
      path: `/v1/admin/regions`,
      method: 'POST',
      body: data,
      secure: true,
      type: ContentType.Json,
      format: 'json',
      ...params,
    });
  /**
   * No description
   *
   * @tags AdminRegionService
   * @name GetRegion1
   * @summary Get Region by ID
   * @request GET:/v1/admin/regions/{regionId}
   * @secure
   */
  getRegion1 = (regionId: number, params: RequestParams = {}) =>
    this.http.request<AdminRegionDto, any>({
      path: `/v1/admin/regions/${regionId}`,
      method: 'GET',
      secure: true,
      format: 'json',
      ...params,
    });
}
